var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrushIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.66658 8.33354C2.55992 8.33354 1.66659 9.22687 1.66659 10.3335C1.66659 11.2069 0.893252 11.6669 0.333252 11.6669C0.946585 12.4802 1.99325 13.0002 2.99992 13.0002C4.47325 13.0002 5.66658 11.8069 5.66658 10.3335C5.66658 9.22687 4.77325 8.33354 3.66658 8.33354ZM12.8066 2.08687L11.9133 1.19354C11.6533 0.933535 11.2333 0.933535 10.9733 1.19354L4.99992 7.16687L6.83325 9.0002L12.8066 3.02687C13.0666 2.76687 13.0666 2.34687 12.8066 2.08687Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrushIcon);
export default __webpack_public_path__ + "static/media/BrushIcon.e7a384ec.svg";
export { ForwardRef as ReactComponent };